import { validationMixin } from 'vuelidate'

export default {
  mixins: [validationMixin]
}
